import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router"

import { Card, Container, Table, Text } from "ui"

import Attribute from "../../records/components/Attribute"
import WithStacks from "data/wrappers/WithStacks"
import WithThumbnail from "data/wrappers/WithThumbnail"

import WithApp from "data/wrappers/WithApp"

const PagesTable = props => {
    var columns = [
        {
            accessor: "name",
            Header: "Name",
            Cell: cell => (
                <Attribute
                    onChange={value => {
                        props.onChange(cell.original._sid, { name: value })
                    }}
                    editable
                    inline
                >
                    {cell.value}
                </Attribute>
            ),
        },
        {
            accessor: "url",
            Header: "URL",
            Cell: cell => (
                <Attribute
                    onChange={value => {
                        props.onChange(cell.original._sid, { url: value })
                    }}
                    editable
                    inline
                >
                    {cell.value}
                </Attribute>
            ),
        },
        {
            accessor: "app_id",
            Header: "App",
            Cell: cell => (
                <Attribute
                    field={{ type: "lookup", lookup_target_id: "apps" }}
                    inline
                    value={cell.value}
                >
                    {cell.value}
                </Attribute>
            ),
        },
        {
            accessor: "is_public",
            Header: "Public page",
            Cell: cell => (
                <Container margin="small">
                    <Attribute
                        onChange={value => {
                            props.onChange(cell.original._sid, { is_public: value })
                        }}
                        field={{ type: "checkbox" }}
                        editable
                        inline
                    >
                        {cell.value}
                    </Attribute>
                </Container>
            ),
        },
        {
            accessor: "_sid",
            Header: "",
            Cell: cell => (
                <Fragment>
                    <Text margin="none">
                        <Link to={"/page/" + cell.value}>Edit</Link>&nbsp;&nbsp;
                        <WithStacks>
                            {({ selectedStack }) => (
                                <WithApp appId={cell.original.app_id}>
                                    {({ app }) => (
                                        <React.Fragment>
                                            <a
                                                href={
                                                    "https://" +
                                                    cancelDoubleSlash(
                                                        selectedStack.base_url +
                                                        app.url +
                                                        cell.original.url
                                                    )
                                                }
                                                target="view"
                                            >
                                                View
                                            </a>&nbsp;&nbsp;
                                            <a
                                                href={
                                                    "/preview" +
                                                    cancelDoubleSlash(app.url + cell.original.url)
                                                }
                                                target="_blank"
                                            >
                                                Preview
                                            </a>
                                        </React.Fragment>
                                    )}
                                </WithApp>
                            )}
                        </WithStacks>
                    </Text>
                </Fragment>
            ),
        },
    ]

    if (props.hideApp) {
        columns = columns.filter(column => column.Header !== "App")
    }

    let data = props.data.filter(page => !page.options.standard_page)
    console.log(props.filters)
    props.filters &&
        Object.keys(props.filters).forEach(
            filterKey => (data = data.filter(data => data[filterKey] === props.filters[filterKey]))
        )

    return (
        <Card>
            <Table columns={columns} data={data} dataLabel="pages" />
        </Card>
    )
}

PagesTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
}
export default PagesTable

const cancelDoubleSlash = url => url.replace("//", "/")



// WEBPACK FOOTER //
// ./src/features/studio/components/PageTable.js